<template>
  <BaseModal
    :aberto="aberto"
    titulo-acessivel="Fale conosco"
    tamanho="lg"
    @fechar="fechar"
  >
    <!-- Passo 1: escolher o perfil -->
    <div v-if="passo === 'inicial'" class="fc-passo1">
      <h3 class="fc-titulo">Como podemos te ajudar agora?</h3>
      <p class="fc-subtitulo">Escolha uma opção e fale direto com o time certo.</p>

      <div class="fc-cards">
        <button type="button" class="fc-card fc-card--suporte" @click="jaSouLojista">
          <i class="bi bi-headset fc-card__icone"></i>
          <span class="fc-card__titulo">Já sou lojista</span>
          <span class="fc-card__frase">Preciso de suporte agora</span>
          <span class="fc-card__legenda">Atendimento prioritário para quem já é parceiro Creditall</span>
        </button>

        <button type="button" class="fc-card fc-card--comercial" @click="passo = 'comercial'">
          <i class="bi bi-shop fc-card__icone"></i>
          <span class="fc-card__titulo">Quero ser lojista</span>
          <span class="fc-card__frase">Quero vender mais e receber garantido</span>
          <span class="fc-card__legenda">Fale agora com o comercial e receba uma proposta</span>
        </button>
      </div>
    </div>

    <!-- Passo 2: canais do comercial -->
    <div v-else class="fc-passo2">
      <button type="button" class="fc-voltar" @click="passo = 'inicial'">
        <i class="bi bi-arrow-left"></i> Voltar
      </button>
      <h3 class="fc-titulo">Fale com nosso time comercial</h3>
      <p class="fc-subtitulo">Escolha um canal, é rapidinho.</p>

      <a
        v-for="w in numeros"
        :key="w.numero"
        :href="link(w.numero)"
        target="_blank"
        rel="noopener"
        class="fc-whats"
        @click="onEscolherWhats(w)"
      >
        <i class="bi bi-whatsapp"></i>
        <span>{{ w.display }}</span>
      </a>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue';
import { WHATSAPPS_COMERCIAL, whatsappUrl } from '../services/contato';
import { analytics } from '../services/analyticsService';

export default {
  name: 'ModalFaleConosco',
  components: { BaseModal },
  props: {
    aberto: { type: Boolean, required: true },
    origem: { type: String, default: 'fale_conosco' },
  },
  emits: ['fechar'],
  data() {
    return { passo: 'inicial', numeros: WHATSAPPS_COMERCIAL };
  },
  watch: {
    aberto(valor) {
      // Sempre reabre no passo inicial.
      if (valor) this.passo = 'inicial';
    },
  },
  methods: {
    fechar() {
      this.$emit('fechar');
    },
    jaSouLojista() {
      analytics.supportClick(this.origem);
      // EhTalkChat está montado globalmente (App.vue); abrimos por evento.
      window.dispatchEvent(new CustomEvent('abrir-ehtalk'));
      this.fechar();
    },
    link(numero) {
      return whatsappUrl(numero);
    },
    onEscolherWhats(w) {
      analytics.ctaComercialClick(`${this.origem}_whatsapp_${w.ddd}`);
      this.fechar();
    },
  },
};
</script>

<style scoped>
.fc-titulo {
  font-size: 22px;
  font-weight: 700;
  color: #191919;
  margin: 0 0 4px;
  text-align: center;
}
.fc-subtitulo {
  font-size: 14px;
  color: #666;
  margin: 0 0 24px;
  text-align: center;
}

.fc-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
@media (max-width: 560px) {
  .fc-cards {
    grid-template-columns: 1fr;
  }
}

.fc-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 6px;
  padding: 24px 16px;
  border-radius: 10px;
  border: 2px solid #eee;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease, transform 0.15s ease;
}
.fc-card:hover {
  transform: translateY(-2px);
}
.fc-card--suporte:hover {
  border-color: #25d366;
}
.fc-card--comercial:hover {
  border-color: #bf1b39;
}

.fc-card__icone {
  font-size: 32px;
  margin-bottom: 4px;
}
.fc-card--suporte .fc-card__icone {
  color: #25d366;
}
.fc-card--comercial .fc-card__icone {
  color: #bf1b39;
}

.fc-card__titulo {
  font-size: 17px;
  font-weight: 700;
  color: #191919;
}
.fc-card__frase {
  font-size: 14px;
  font-weight: 600;
  color: #444;
}
.fc-card__legenda {
  font-size: 12px;
  color: #888;
}

.fc-voltar {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 0;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  padding: 0;
  margin-bottom: 12px;
}
.fc-voltar:hover {
  color: #191919;
}

.fc-whats {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 8px;
  border: 1px solid #eee;
  color: #191919;
  text-decoration: none;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.fc-whats:hover {
  border-color: #25d366;
  background: #f4fdf7;
  color: #191919;
}
.fc-whats i {
  color: #25d366;
  font-size: 20px;
}
</style>
